import React, { useEffect, useState } from 'react'
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm'
import apiService from '../../Services/apiServices'
import helper from '../../Services/helper'

const Warehouse = (props) => {
    const [branches, setBranches] = useState()
    const [modal, setModal] = useState()

    const t = (key) => {
        return helper().translate(key);
    }

    const headers = [
        { key: 'name', columnName: t('NAME'), type: 'input', required: true },
        { key: 'branchId', name: "branchName", columnName: t('BRANCH'), type: 'select', options: branches,  required: false },
        { key: 'address', columnName: t('ADDRESS'), type: 'input', required: false },
        { key: 'contactPerson', columnName: t('CONTACT_PERSON'), type: 'input', required: false },
        { key: 'email', columnName: t('EMAIL'), type: 'input', required: false },
        { key: 'phone', columnName: t('PHONE'), type: 'input', required: false },
    ]

    const model = {
        id: 0,
        name: "",
        unitNo: "", 
        address: "",
        contactPerson: "",
        email: "",
        phone: "",
        otherData: "",
        status: 0
    }

    const getBranches = () => {
        apiService().get('branches')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.map(record => ({ value: record.id, label: record.name }));
                    setBranches(records)
                }
            })
    }

    const performRefresh = () => {
        alert('reffff')
    }

    useEffect(() => {
        getBranches();
    }, [])

    useEffect(() => {
        setModal(props.modal)
    }, [props.modal]);

    return (
        <div>
            <AdministrationForm new={modal} headers={headers} table="Warehouses" name="Depo" model={model} formType="modal" />
        </div>
    )
}

export default Warehouse
